export const filter = {
    id: "",
    index: "",
    comment: "",
    search: "",
    created_at: "",
    updated_at: "",
};
